import React from "react";
import {
  Check, Star, Shield, Flame, Award, Leaf, Zap, Crown, Sparkles, ThumbsUp,
  DollarSign, Banknote, Bitcoin, Wallet, CreditCard, Tag, Truck, Store, Gem, Diamond,
} from "lucide-react";

const MAP = {
  check: Check, star: Star, shield: Shield, flame: Flame, award: Award, leaf: Leaf,
  zap: Zap, crown: Crown, sparkles: Sparkles, "thumbs-up": ThumbsUp, gem: Gem, diamond: Diamond,
  "dollar-sign": DollarSign, banknote: Banknote, bitcoin: Bitcoin, wallet: Wallet,
  "credit-card": CreditCard, tag: Tag, truck: Truck, store: Store,
};

export const BADGE_ICON_OPTIONS = ["star", "shield", "flame", "award", "leaf", "zap", "crown", "sparkles", "thumbs-up", "gem", "diamond", "check"];
export const PAYMENT_ICON_OPTIONS = ["dollar-sign", "banknote", "bitcoin", "wallet", "credit-card"];

export function DynIcon({ name, ...props }) {
  const Comp = MAP[name] || Star;
  return <Comp {...props} />;
}
